/* Zayluna: Menge im Warenkorb in Einzelschritten (1 / 2 / 3 Monats-Vorrat, darüber je +1 Flasche).
   Seit 25.09.2026 als Shopify-Rabatt: im Warenkorb liegen n Einzelflaschen (ZAY-1) + je volle 3 Flaschen eine
   Gratis-Flasche (ZAY-G, 0 €). Den Paketpreis rechnen die automatischen Rabatte „2 Monats-Vorrat" und
   „3 Monats-Vorrat" — deshalb steht er auch im Checkout. Alte Paket-Zeilen (ZAY-2/ZAY-3) werden beim ersten
   Klick auf Einzelflaschen umgestellt.
   Flüssig: die Zahl springt sofort um, schnelle Klicks werden gesammelt und als EIN Aufruf geschickt,
   danach wird nur der Warenkorb-Inhalt ausgetauscht (kein Neuladen, kein erneutes Aufklappen). */
(function () {
  if (window.__cgCartBundles) return; window.__cgCartBundles = true;

  const post = async (url, body) => {
    const r = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    if (!r.ok) throw new Error(url + ' ' + r.status);
    return r.json();
  };

  // Warenkorb-Element des aktuellen Kontexts (Schubfach oder Warenkorbseite) und seine Dawn-Abschnitte
  const cartEl = (from) => (from && from.closest('cart-drawer-items, cart-items')) || document.querySelector('cart-drawer-items') || document.querySelector('cart-items');
  const sectionsOf = (el) => { try { return el.getSectionsToRender(); } catch (e) { return []; } };
  const paint = (el, list, state) => {
    if (!state || !state.sections || !list.length) return location.reload();
    const parse = (html, sel) => new DOMParser().parseFromString(html, 'text/html').querySelector(sel);
    list.forEach((s) => {
      const html = state.sections[s.section]; if (!html) return;
      const ziel = document.getElementById(s.id); if (!ziel) return;
      const box = ziel.querySelector(s.selector) || ziel, quelle = parse(html, s.selector);
      if (quelle) box.innerHTML = quelle.innerHTML;
    });
    const drawer = document.querySelector('cart-drawer');
    if (drawer && state.item_count === 0) drawer.classList.add('is-empty');
  };
  const send = async (el, updates, alteZeile) => {
    const list = sectionsOf(el);
    if (alteZeile) await post('/cart/change.js', { id: alteZeile, quantity: 0 });
    return post('/cart/update.js', { updates, sections: list.map((s) => s.section), sections_url: location.pathname });
  };

  /* ⛔ 23.09.2026: /cart/add.js lässt die Meta-App ein „In den Einkaufswagen" senden — auch beim Verringern.
     Deshalb hier nur /cart/update.js bzw. /cart/change.js; die legen die Gratis-Flasche bei Bedarf selbst an. */
  /* ⛔ 25.09. abends: Zahl sprang hin und her. Ursache: (1) nach dem Abschicken las der nächste Klick die ALTE Menge
     aus data-cg-months (Antwort noch unterwegs) → 4 → 5 wurde wieder 4; (2) jede Antwort malte den Warenkorb neu,
     auch wenn inzwischen weitergeklickt war → Zahl sprang auf den älteren Stand zurück. Jetzt gilt EIN Wunschwert,
     Antworten werden nur gemalt, wenn danach nichts mehr geklickt wurde, und die alte Paket-Zeile wird nur einmal entfernt. */
  let wunsch = null;   // zuletzt geklickte Menge, solange Shopify noch nicht nachgezogen hat
  let serie = null;    // { v1, vg, alt } — alt = Schlüssel einer ZAY-2/ZAY-3-Zeile, die einmalig entfernt wird
  let timer = null, stand = 0, laeuft = Promise.resolve();

  const abschicken = () => {
    timer = null;
    const nr = ++stand, el = cartEl(document.querySelector('quantity-input[data-cg-months]'));
    laeuft = laeuft.then(async () => {
      if (nr !== stand || !serie) return; // inzwischen neuer Klick → der spätere Aufruf übernimmt
      try {
        const n = wunsch, alt = serie.alt;
        const updates = {}; updates[serie.v1] = n; updates[serie.vg] = Math.floor(n / 3);
        const state = await send(el, updates, alt);
        if (alt) serie.alt = null;
        if (nr !== stand || timer) return; // weitergeklickt: nicht mit altem Stand übermalen
        wunsch = null; serie = null;
        paint(el, sectionsOf(el), state);
      } catch (err) {
        console.error('[cg-cart-bundles]', err);
        location.reload();
      }
    });
  };

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('quantity-input[data-cg-months] .quantity__button');
    if (!btn) return;
    const qi = btn.closest('quantity-input'), plus = btn.name === 'plus';
    const v1 = qi.dataset.cgV1, vg = qi.dataset.cgVg;
    if (!v1 || !vg) return;
    e.preventDefault(); e.stopImmediatePropagation();

    if (!serie) serie = { v1, vg, alt: qi.dataset.cgSku !== 'ZAY-1' ? qi.dataset.cgKey : null };
    const cur = wunsch !== null ? wunsch : +qi.dataset.cgMonths;
    const n = Math.max(0, plus ? cur + 1 : cur - 1); /* Owner 25.09.: immer nur eine Flasche mehr/weniger */
    wunsch = n;
    stand++; // laufende Antworten dürfen nicht mehr malen
    clearTimeout(timer); timer = setTimeout(abschicken, 280);

    // sofort sichtbar: neue Zahl, Preise folgen nach der Antwort
    const anzeige = qi.querySelector('.cg-qty-display'); if (anzeige) anzeige.textContent = n;
    const feld = qi.querySelector('.quantity__input'); if (feld) feld.value = n;
    vorschau(qi, n);
  }, true);

  /* Sofort-Vorschau der Preise, damit nichts „hängt" (Shopify braucht ~1 s für die Rabattrechnung).
     ⛔ Muss zu den automatischen Rabatten passen: 1 = 39,90 · 2 = 47,98 (−15,91 je Flasche) · ab 3 = 19,99 je Flasche.
     Die Antwort von Shopify überschreibt die Vorschau danach ohnehin mit den echten Werten. */
  const EINZEL = 3990;
  const paketpreis = (n) => (n <= 0 ? 0 : n === 1 ? EINZEL : n === 2 ? 4798 : 1999 * n);
  const geld = (c) => '€' + (c / 100).toFixed(2).replace('.', ',');
  const setze = (root, sel, text) => root && root.querySelectorAll(sel).forEach((el) => { el.textContent = text; });
  function vorschau(qi, n) {
    const zeile = qi.closest('.cart-item'); if (!zeile || n <= 0) return;
    const preis = paketpreis(n), gratis = Math.floor(n / 3);
    setze(zeile, '.cg-cart-unit__price', geld(Math.floor(preis / (n + gratis))));
    setze(zeile, '.cart-item__discounted-prices .price:not(s), .cart-item__discounted-prices dd.price', geld(preis));
    setze(zeile, '.cart-item__old-price', geld(EINZEL * n));
    setze(zeile, '.product-option dd', n + ' Monats-Vorrat'); // Zeile „Vorrat: n Monats-Vorrat“
    // Gratis-Flaschen-Zeile (steht direkt darunter) sofort ein-/ausblenden und mitzählen
    const gz = zeile.nextElementSibling;
    if (gz && gz.classList.contains('cg-gift-row')) { gz.style.display = gratis ? '' : 'none'; setze(gz, '.cg-gift-qty', String(gratis)); }
    const box = zeile.closest('cart-drawer, #main-cart-items, form') ? document : null;
    // Summen nur ohne Rabattcode vorab zeigen — mit Code rechnet erst Shopify richtig
    if (box && !document.querySelector('.discounts__discount--end') && document.querySelectorAll('quantity-input[data-cg-months]').length === 1) {
      setze(document, '.totals__total-value', geld(preis));
      setze(document, '.cg-cart-savings__value', geld(EINZEL * n - preis));
    }
  }

  /* Gratis-Flaschen nie ohne gekaufte Flaschen (z. B. nach „Entfernen") */
  let syncing = false;
  const sync = async () => {
    if (syncing || serie) return; syncing = true;
    try {
      const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      let n = 0, g = 0, vg = null;
      cart.items.forEach((i) => { if (i.sku === 'ZAY-1') n += i.quantity; if (i.sku === 'ZAY-G') { g += i.quantity; vg = i.variant_id; } });
      const soll = Math.floor(n / 3);
      if (g > soll && vg) { const el = cartEl(); const updates = {}; updates[vg] = soll; paint(el, sectionsOf(el), await send(el, updates)); }
    } catch (err) { console.error('[cg-cart-bundles] sync', err); }
    syncing = false;
  };
  /* PUB_SUB_EVENTS ist ein globales const (constants.js) und hängt NICHT an window */
  if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof subscribe === 'function') subscribe(PUB_SUB_EVENTS.cartUpdate, (ev) => { if (ev && ev.source !== 'product-form') setTimeout(sync, 50); });
  sync();

  const css = document.createElement('style');
  css.textContent = '.cart-item.cg-pending .cart-item__totals,.cart-item.cg-pending .cg-cart-unit{opacity:.55;transition:opacity .15s}';
  document.head.appendChild(css);
})();
